module.exports = __webpack_public_path__ + "static/lokalizacja-puck-4404b93f05e4e89a8a27a5f3f308a54f.jpg";